<body [ngStyle]="{'background-color': flagCliente ? '#0a0a0a': '#fff'}" [ngClass]="flagCliente ? 'fondo': '' ">


  <div class="main-content">
    <div style="padding: 0px 15px;">

      <nexus-alert></nexus-alert>
    </div>
    <div class="main-content-wrap">
      <div class="item-registro">

        <router-outlet></router-outlet>

      </div>
    </div>
  </div>

</body>
<mga-google-analytics></mga-google-analytics>
<app-modal-carga style="display : none;"></app-modal-carga>